import { PaymentChannelTypeSlug } from '../../';

export class PaymentChannelPurchasePlanParams {
  // One of
  lineId?: string;
  phoneNumber?: string;
  endUserId?: string;
  iccid?: string;

  msisdn?: string; // Use for payment channel
  consumerIdentityUuid?: string; // Use to gift plans
  planUuid: string;
  storeExternalId?: string; // Optional
  paymentChannelTypeSlug: PaymentChannelTypeSlug; // In URL, accepts values such as 'sale' or 'portal'
  recurrenceCount?: number;
  billToAccountId?: string;
  memo?: string;
  externalTransactionId?: string;
}
